import { WebToRNMessage, WebToRNPayloadList } from './nativeEvents';
import { NativeSupportedEventKeys } from './nativeProps';

export const runningInRNWebView = !!window?.ReactNativeWebView;

export const postMessageRN = <Action extends keyof WebToRNPayloadList>(message: WebToRNMessage<Action>): void =>
    window?.ReactNativeWebView?.postMessage(JSON.stringify(message));

export const isEventSupported = (event: NativeSupportedEventKeys): boolean | undefined =>
    window?.ReactNativeProps?.supportsEvent && window.ReactNativeProps.supportsEvent[event];
